import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import LandingPage from './components/LandingPage';
import Map from './components/Map';
import AdminPanel from './components/AdminPanel';
import AdminLogin from './components/AdminLogin';
import { ThemeProvider } from './contexts/ThemeContext';
import './index.css';

// Protected Route Component
const ProtectedAdminRoute = ({ children }) => {
  const adminPassword = sessionStorage.getItem('adminPassword');
  
  if (!adminPassword) {
    return <Navigate to="/bubptate/master" replace />;
  }
  
  return children;
};

// Admin Panel Wrapper with navigation
const AdminPanelWrapper = () => {
  const navigate = useNavigate();
  const adminPassword = sessionStorage.getItem('adminPassword');

  const handleLogout = () => {
    sessionStorage.removeItem('adminPassword');
    navigate('/bubptate/master');
  };

  const handleBackToMap = () => {
    navigate('/');
  };

  return (
    <>
      <AdminPanel adminPassword={adminPassword} />
      {/* Navigation buttons */}
      <div className="fixed bottom-4 right-4 flex space-x-2 z-50">
        <button
          onClick={handleBackToMap}
          className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-lg transition-colors"
        >
          ← Back to Map
        </button>
        <button
          onClick={handleLogout}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-lg transition-colors flex items-center space-x-1"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span>Logout</span>
        </button>
      </div>
    </>
  );
};

function App() {
  const [view, setView] = useState('landing');
  
  useEffect(() => {
    // Only clear on first mount
    const hasVisited = sessionStorage.getItem('hasVisited');
    if (!hasVisited) {
      // localStorage.clear(); // Removed to persist user preferences (map style, votes) across sessions
      sessionStorage.setItem('hasVisited', 'true');
    }
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <Analytics />
        <div className="w-full h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
          <Routes>
            {/* Landing Page */}
            <Route path="/" element={
              view === 'landing' ? (
                <LandingPage onEnter={() => setView('map')} />
              ) : (
                <Map />
              )
            } />
            
            {/* Admin Login */}
            <Route path="/bubptate/master" element={<AdminLogin />} />
            
            {/* Protected Admin Dashboard */}
            <Route 
              path="/bubptate/master/dashboard" 
              element={
                <ProtectedAdminRoute>
                  <AdminPanelWrapper />
                </ProtectedAdminRoute>
              } 
            />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
